import { Stack } from '@mantine/core';
import type { IconNames } from '@repo/foundations';
import { Icon } from '@repo/foundations';
import type { ColorNames } from '@repo/theme/utils';

export function NoticeDropdown({
	value,
	options,
	onChange,
}: {
	value: string;
	options: {
		value: string;
		label: string;
		iconName: IconNames;
		iconColor: ColorNames;
	}[];
	onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}) {
	const selectedOption = options.find((opt) => opt.value === value);

	return (
		<div
			contentEditable={false}
			style={{
				position: 'relative',
			}}
		>
			<select
				value={value}
				onChange={onChange}
				style={{
					position: 'absolute',
					opacity: 0,
					cursor: 'pointer',
				}}
			>
				{options.map((opt) => (
					<option key={opt.value} value={opt.value}>
						{opt.label}
					</option>
				))}
			</select>

			<Stack className={`stack ${selectedOption?.label}`}>
				<Icon
					name={selectedOption?.iconName ?? 'questionMark'}
					style={{ pointerEvents: 'none' }}
					color={selectedOption?.iconColor ?? 'icon/primary/default'}
				/>
			</Stack>
		</div>
	);
}
